export { default } from './Ptinfo';
